import { render, staticRenderFns } from "./AnalyticDetails.vue?vue&type=template&id=899b72fc&scoped=true"
import script from "./AnalyticDetails.vue?vue&type=script&lang=js"
export * from "./AnalyticDetails.vue?vue&type=script&lang=js"
import style0 from "./AnalyticDetails.vue?vue&type=style&index=0&id=899b72fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899b72fc",
  null
  
)

export default component.exports